module.exports = __webpack_public_path__ + "static/img/lg-archive.61c2385.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/lg-archive.jpg
// module id = ujN9
// module chunks = 0